import Swiper from "swiper";
import { Pagination, Autoplay, EffectFade, Navigation } from "swiper/modules";

const latestOffersCarousels = document.querySelectorAll(".latest-offers-carousel");

latestOffersCarousels.forEach(carousel => {
    const swiperHolderEl = carousel.querySelector(".swiper-holder");
    const swiperPaginationEl = carousel.querySelector(".swiper-pagination");
    const swiperEl = swiperHolderEl.querySelector(".swiper");
    const nextEl = swiperHolderEl.querySelector(".next");
    const prevEl = swiperHolderEl.querySelector(".prev");

    const swiper = new Swiper(swiperEl, {
        modules: [Pagination, Autoplay, EffectFade, Navigation],
        watchOverflow: true,
        pagination: {
            el: swiperPaginationEl,
            type: "bullets",
            clickable: true,
        },
        navigation: {
            nextEl: nextEl,
            prevEl: prevEl,
        },
        autoplay: {
            delay: 6000,
        },
        effect: "fade",
        fadeEffect: {
            crossFade: true,
        },
        pauseOnMouseEnter: true,
        on: {
            init(sw) {
                if (this.slides.length === 1) {
                    swiperPaginationEl.style.display = "none";
                    nextEl.style.display = "none";
                    prevEl.style.display = "none";
                } else {
                    carousel.querySelector(".swiper-counter").innerHTML = (sw.activeIndex + 1) + " / " + sw.slides.length;
                }
            },
            slideChangeTransitionEnd: function (sw) {
                carousel.querySelector(".swiper-counter").innerHTML = (sw.activeIndex + 1) + " / " + sw.slides.length;
            }
        },
    });
});
